import { computed, inject, Injectable, signal } from '@angular/core';
import { CustomRouteService } from '../../../services/custom-route.service';
import { RestService } from 'src/app/services/rest.service';
import { HttpClient } from '@angular/common/http';
import { RegisterUserService } from 'src/app/pages/register-user/services/register-user.service';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { StatisticsService } from 'src/app/services/statistics.service';
import { map, catchError, throwError, finalize } from 'rxjs';
import { SendCustomRouteForm } from '../interfaces/more.interface';

@Injectable({
  providedIn: 'root'
})
export class SendRouteEmailService {  
  private _restService = inject(RestService);
  private _http = inject(HttpClient);
  private _translateService = inject(TranslateService);
  private _googleTranslateService = inject(GoogleTranslateService);;
  private _registerUserService = inject(RegisterUserService)
  private _customRouteService = inject(CustomRouteService);
  private _authService = inject(AuthService);
  private _dataChatService = inject(DataChatService);
  private _statisticsService = inject(StatisticsService);
  
  private readonly _registerUserForm = computed(() => this._registerUserService.registerUserForm());
  private readonly _token = computed(() => this._customRouteService.token());
  private readonly _numberOfDaysCustomRoute = computed(() => this._registerUserService.numberOfDaysCustomRoute());

  public isSendingRouteToEmail = signal<boolean>(false);
  
  private getBodyStructureToSendRouteByEmail(formValue: SendCustomRouteForm){    
    const categoryIdList = this._registerUserForm()?.interestIdList;
    const tripTypeIdList = this._registerUserForm()?.tripType.toString();

    return {
      distributorID: this._restService?.device?.distributorID,
      clientID: this._restService?.device?.client,
      deviceID: this._restService?.device?.device ?? 0,
      channelID: this._restService?.device?.channel,
      route: null, // we send now de route token
      routeToken: this._token(),
      days: this._numberOfDaysCustomRoute(),
      nombre: formValue?.name,
      email: formValue?.email,
      info: formValue?.extraInfo,
      language: this._googleTranslateService.getCookieLang() || this._translateService.currentLang || 'es',
      pdfs: null, // TODO: EN EMT NO HAY PDFs
      recommended: null, // TODO: EN EMT NO HAY RECOMMENDED
      name_route: null, // TODO: EN EMT NO HAY NAME_ROUTE
      users_webapp_id: this._authService.userValue?.id ?? null,
      travelerType: tripTypeIdList,
      categories: categoryIdList,
      subCategories: null, // TODO: EN EMT NO HAY SUBCATEGORIES
      additionalInfo: null, // TODO: EN EMT NO HAY ADDITIONAL INFO
      appID: this._restService?.device?.appID,
      type: this._restService?.device?.type,
      owner: this._restService?.device?.type == 'distributor' ? 'distributor' : 'client',
      chatToken: this._dataChatService.token(),
      sessionId: this._statisticsService.sessionId,
      image: null, // TODO: EN EMT NO HAY IMAGE
      withoutRoute: false, // TODO: EN EMT NO HAY WITHOUT ROUTE
    }
  }

  sendRouteByEmail(formValue: SendCustomRouteForm): any {
    this.isSendingRouteToEmail.set(true);
    
    const url = `${this._restService.apiUrlBase}/api/pwa-save-route`;
    const body = this.getBodyStructureToSendRouteByEmail(formValue);
    console.log("saveRoute body:", body);
    
    const formData = new FormData();
    formData.append("data", JSON.stringify(body));

    return this._http.post(url, formData)
      .pipe(
        map((response: any) => { // TODO: TYPE RESPONSE
          console.log("Response from sendRouteByEmail:", response);
          return response;
        }),
        catchError((error) => {
          console.error(`Error sending route by email: ${error}`);
          return throwError(() => new Error('HTTP request failed', { cause: error }));
        }),
        finalize(() => {
          this.isSendingRouteToEmail.set(false);
        })
      )
  }
}
